module.exports = __webpack_public_path__ + "img/icon-check-blue.bcf25e11.svg";